var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.125H6.80156C7.59744 8.12498 8.38183 8.31495 9.08951 8.67912C9.79719 9.04328 10.4077 9.57112 10.8703 10.2188L14.1297 14.7812C14.5923 15.4289 15.2028 15.9567 15.9105 16.3209C16.6182 16.685 17.4026 16.875 18.1984 16.875H20.625",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 6.25L20.625 8.125L18.75 10",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 15L20.625 16.875L18.75 18.75",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0359 10.3492L14.1296 10.2188C14.5922 9.57112 15.2028 9.04328 15.9104 8.67912C16.6181 8.31495 17.4025 8.12498 18.1984 8.125H20.625",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 16.8746H6.80156C7.59744 16.8746 8.38183 16.6847 9.08951 16.3205C9.79719 15.9563 10.4077 15.4285 10.8703 14.7809L10.9641 14.6504",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/Swap.2e66630348a804b465cb1a2a37f55f03.svg";
export { ForwardRef as ReactComponent };